const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.170.2.json');
const SenseUtilities = require('enigma.js/sense-utilities');

const config = {
  host: 'sense-demo.qlik.com',
  // appId: '91b224d7-f300-423e-858b-17b399a08820',
  appId: 'd2ac234f-68cd-4f18-b77d-a399bdabbffc',
  // host: 'sense-demo-staging.qlik.com',
  // appId: '91b224d7-f300-423e-858b-17b399a08820',
};
const url = SenseUtilities.buildUrl(config);
const session = enigma.create({ schema, url });

export default session.open().then((global) => global.openDoc(config.appId));

// const enigma = require('enigma.js');
// const schema = require('enigma.js/schemas/12.170.2.json');
// // const SenseUtilities = require('enigma.js/sense-utilities');

// const config = {
//   host: 'localhost:4848',
//   // appId: '91b224d7-f300-423e-858b-17b399a08820',
//   appId: 'C:\\Users\\oim\\OneDrive - QlikTech Inc\\Documents\\Qlik\\Sense\\Apps\\Canadian Journalist Diversity - 2022.qvf',
//   // host: 'sense-demo-staging.qlik.com',
//   // appId: '91b224d7-f300-423e-858b-17b399a08820',
// };
// // const url = SenseUtilities.buildUrl(config);
// const session = enigma.create({ schema, url: 'ws://localhost:4848/app/C%3A%5CUsers%5Coim%5COneDrive%20-%20QlikTech%20Inc%5CDocuments%5CQlik%5CSense%5CApps%5CCanadian%20Journalist%20Diversity%20-%202022.qvf' });

// export default session.open().then((global) => global.openDoc(config.appId));
